import _ from "lodash";
export const selectCurrentStep = state => {
  const currentStepId = state.loan.currentStep;
  const nextStep =
    !_.isEmpty(state.loan.templateJson.steps) &&
    _.find(state.loan.templateJson.steps, step => step.id === currentStepId);
  return nextStep;
};
